import axios from 'axios';

const API_BASE = rmVars.api_url

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // 로그인/쿠키 필요한 엔드포인트 대비
});

// 공용 fetch 헬퍼 (GET)
export async function get(path, { params, headers } = {}) {
  const defaultHeaders = {
    'X-WP-Nonce': typeof rmVars !== 'undefined' ? rmVars.api_nonce : '',
  };
  const mergedHeaders = { ...defaultHeaders, ...headers };

  // url이 /rm/v1/로 시작하는 경우, baseURL에서 /rm/v1 부분 제거 (중복 방지)
  const baseUrl = API_BASE;
  let finalPath;
  if (path.startsWith('/rm/v1/') || path.startsWith('/rm/v1')) {
    // baseUrl에서 끝에 /rm/v1/ 또는 /rm/v1이 있으면 제거하고 path 사용
    const cleanBaseUrl = baseUrl.replace(/\/rm\/v1\/?$/, '');
    // axios 인스턴스의 baseURL을 임시로 변경하기 위해 직접 axios 호출
    const finalUrl = cleanBaseUrl + path;
    const res = await axios.get(finalUrl, {
      params,
      headers: mergedHeaders,
      withCredentials: true
    });
    return res.data;
  } else {
    // path가 /rm/v1로 시작하지 않으면 axios 인스턴스 사용
    finalPath = path;
    const res = await api.get(finalPath, { params, headers: mergedHeaders });
    return res.data;
  }
}

// 필요하면 POST/PUT/DELETE 도 추가
export async function post(path, body, { params, headers } = {}) {
  const defaultHeaders = {
    'X-WP-Nonce': typeof rmVars !== 'undefined' ? rmVars.api_nonce : '',
  };
  const mergedHeaders = { ...defaultHeaders, ...headers };

  // url이 /rm/v1/로 시작하는 경우, baseURL에서 /rm/v1 부분 제거 (중복 방지)
  const baseUrl = API_BASE;
  let finalPath;
  if (path.startsWith('/rm/v1/') || path.startsWith('/rm/v1')) {
    // baseUrl에서 끝에 /rm/v1/ 또는 /rm/v1이 있으면 제거하고 path 사용
    const cleanBaseUrl = baseUrl.replace(/\/rm\/v1\/?$/, '');
    // axios 인스턴스의 baseURL을 임시로 변경하기 위해 직접 axios 호출
    const finalUrl = cleanBaseUrl + path;
    const res = await axios.post(finalUrl, body, {
      params,
      headers: mergedHeaders,
      withCredentials: true
    });
    return res.data;
  } else {
    // path가 /rm/v1로 시작하지 않으면 axios 인스턴스 사용
    finalPath = path;
    const res = await api.post(finalPath, body, { params, headers: mergedHeaders });
    return res.data;
  }
}

// 공통 API 함수 (getData, postData 등)
export async function getData(url, args = {}) {
  const baseUrl = typeof rmVars !== 'undefined' ? rmVars.restApi : API_BASE;

  // url이 /rm/v1/로 시작하는 경우, baseUrl에서 /rm/v1 부분 제거 (중복 방지)
  let finalUrl;
  if (url.startsWith('/rm/v1/') || url.startsWith('/rm/v1')) {
    // baseUrl에서 끝에 /rm/v1/ 또는 /rm/v1이 있으면 제거
    const cleanBaseUrl = baseUrl.replace(/\/rm\/v1\/?$/, '');
    finalUrl = cleanBaseUrl + url;
  } else {
    // url이 /rm/v1로 시작하지 않으면 그대로 연결
    finalUrl = baseUrl + (url.startsWith('/') ? url : '/' + url);
  }

  const options = {
    method: 'GET',
    params: args,
    headers: {
      'X-WP-Nonce': typeof rmVars !== 'undefined' ? rmVars.api_nonce : '',
    },
    url: finalUrl,
  };
  let response = null;
  await axios(options).then((res) => {
    if (res.data.status) {
      response = res.data.result;
    }
  }).catch((error) => {
    // response = null;
  });
  return response;
}

export async function postData(url, body = {}, args = {}) {
  const baseUrl = typeof rmVars !== 'undefined' ? rmVars.restApi : API_BASE;

  // url이 /rm/v1/로 시작하는 경우, baseUrl에서 /rm/v1 부분 제거 (중복 방지)
  let finalUrl;
  if (url.startsWith('/rm/v1/') || url.startsWith('/rm/v1')) {
    // baseUrl에서 끝에 /rm/v1/ 또는 /rm/v1이 있으면 제거
    const cleanBaseUrl = baseUrl.replace(/\/rm\/v1\/?$/, '');
    finalUrl = cleanBaseUrl + url;
  } else {
    // url이 /rm/v1로 시작하지 않으면 그대로 연결
    finalUrl = baseUrl + (url.startsWith('/') ? url : '/' + url);
  }

  const options = {
    method: 'POST',
    data: body,
    params: args,
    headers: {
      'X-WP-Nonce': typeof rmVars !== 'undefined' ? rmVars.api_nonce : '',
    },
    url: finalUrl,
  };
  let response = null;
  await axios(options).then((res) => {
    if (res.data.status) {
      response = res.data.result;
    }
  }).catch((error) => {
    // response = null;
  });
  return response;
}

